import { createBrowserClient } from "@supabase/ssr";

// Check if running in iframe (only on client side)
const isInIframe = () => {
    if (typeof window === 'undefined') return false; // Server-side check
    try {
        return window.self !== window.top;
    } catch (e) {
        return true; // If we can't access window.top, we're probably in an iframe
    }
};

export const createClient = () => {
    const inIframe = isInIframe();

    return createBrowserClient(
        process.env.NEXT_PUBLIC_SUPABASE_URL!,
        process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
        {
            db: { schema: process.env.NEXT_PUBLIC_SUPABASE_DB_SCHEMA },
            ...(inIframe && {
                cookies: {
                    getAll() {
                        // Server-side safety check
                        if (typeof document === 'undefined') return [];

                        return document.cookie
                            .split(';')
                            .map(cookie => cookie.trim().split('='))
                            .filter(([name]) => name)
                            .map(([name, value]) => ({
                                name: decodeURIComponent(name),
                                value: decodeURIComponent(value || '')
                            }));
                    },
                    setAll(cookiesToSet) {
                        // Server-side safety check
                        if (typeof document === 'undefined') return;

                        cookiesToSet.forEach(({ name, value, options = {} }) => {
                            // Apply iframe-specific cookie settings
                            const cookieOptions = {
                                ...options,
                                sameSite: 'None',
                                secure: true,
                            };

                            let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

                            if (cookieOptions.maxAge) {
                                cookieString += `; Max-Age=${cookieOptions.maxAge}`;
                            }
                            if (cookieOptions.expires) {
                                cookieString += `; Expires=${cookieOptions.expires.toUTCString()}`;
                            }
                            if (cookieOptions.path) {
                                cookieString += `; Path=${cookieOptions.path}`;
                            }
                            if (cookieOptions.domain) {
                                cookieString += `; Domain=${cookieOptions.domain}`;
                            }
                            if (cookieOptions.sameSite) {
                                cookieString += `; SameSite=${cookieOptions.sameSite}`;
                            }
                            if (cookieOptions.secure) {
                                cookieString += `; Secure`;
                            }
                            if (cookieOptions.httpOnly) {
                                cookieString += `; HttpOnly`;
                            }

                            document.cookie = cookieString;
                        });
                    },
                },
                auth: {
                    persistSession: true,
                    detectSessionInUrl: false, // Important for iframes
                    flowType: 'pkce',
                },
            }),
        }
    );
};